import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { WeighListing } from './Pages'

export const WeighingReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={WeighListing} />
    </Fragment>
)